import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { USER_LEVEL } from 'constants/global';
import useConfiguration from './useConfiguration';

const useKLU = () => {
  const { user } = useSelector((state) => state.session);
  const { getConfigurationValue } = useConfiguration();

  const enabled = useMemo(() => {
    if (!user?.clientId || user?.level !== USER_LEVEL.COMPLETE) {
      return false;
    }
    const users = (getConfigurationValue('usersKlu') || '').split(',');
    return users.includes(user.clientId) || users.includes('all');
  }, [getConfigurationValue, user]);

  return {
    enabled,
    account: user.clabe,
  };
};

export default useKLU;
